<div class="row">
  <div class="col-md-9 col-lg-7">
    <div class="c-progress mt-4">
      <p class="c-progress__status">Step {{currentStep}} of {{totalSteps}}</p>
      <ol class="c-progress__list">
        @for (i of range; track i) {
          <li class="c-progress__item" [ngClass]="{'is-completed': (i < currentStep), 'is-active': (i === currentStep)}">
            <span class="c-progress__marker">
              <span class="visually-hidden">Step {{currentStep}}</span>
            </span>
          </li>
        }
      </ol>
    </div>
  </div>
</div>
